import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import cafLogo from "../../assets/CAF-logo.png";
import "./index.css";
import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import MatchesCalendar from "../../components/MatchesCalendar/MatchesCalendar";
import SportsSectionHeader from "../../components/sportsSectionHeader/sportsSectionHeader.component";
import TopStories from "../../components/News/TopStories";
import AllMedia from "../../components/News/AllMedia";
import FanClub from "../../components/FanClub";
import useServiceAndSport from "../../hooks/useServiceAndSport";
import CupTournamentGroupsStanding from "../../components/TournamentStanding/CupTournamentGroupsStanding/CupTournamentGroupsStanding";
import { getUserPhoneNumbers, logFailedApi } from "../../globalFn";
import { sharedComponentsContext } from "../../context/shared-context";
import { useQuery } from "@tanstack/react-query";
import api from "../../apis";
import MatchCard from "../../components/MatchCard/MatchCard";
import { IDS } from "../../globalData";
import MatchesCalendarLoader from "../../components/MatchesCalendar/MatchesCalendarLoader";
import ErrorMsg from "../../components/ErrorPage/ErrorMsg";
import PredictAfconTeams from "../../components/PredictAfconTeams";

const apiFn = (params) => api.seasons.getSeasons(params);
const apiFnTwo = (params) => api.tournament.getTournamentsStanding(params);
const apiGetMatchesFn = (params) => api.matches.get(params);
const getAllPredictionMatches = (params) =>
  api.predictAndWin.getAllPredictionMatches(params);

export default function AfricanNationsCup() {
  const history = useHistory();
  const { pathname } = useLocation();
  const { id } = useParams();
  const { serviceId, sportId } = useServiceAndSport();
  const [teams, SetTeams] = useState({});
  const [showPredictAndWin, setShowPredictAndWin] = useState(false);

  // const {
  //   seasonInfo: { activeSeason },
  // } = useContext(sharedComponentsContext);
  const currentTab = pathname.split("/").at(-1);
  const [selectedKey, setSelectedKey] = useState(currentTab);
  const date = new Date();
  const { isLoading, data = {} } = useQuery({
    queryKey: ["seasons", id],
    queryFn: () => apiFn({ tournament_id: id }),
    select: (data) => data,
    refetchOnWindowFocus: false,
  });
  const {
    isLoading: isLoadingTournamentStanding,
    isError: isErrorTournamentStanding,
    data: tournamentStanding = {},
  } = useQuery({
    queryKey: ["tournament-standing", sportId, data?.lastSeason?.id, id],
    queryFn: () =>
      apiFnTwo({
        sport_id: sportId,
        season_id: data?.lastSeason?.id,
        tournament_id: id,
      }),
    onError: () => logFailedApi("tournament-standing"),
    select: ({ data, tournament }) => {
      const competitionType = data[0].competition_type.name;
      const isCup = competitionType === "cup";
      const standing = isCup
        ? Object.values(data[0]["Group Stage"] || [])
        : data[0].data.map((el) => ({ ...el, checked: false }));
      return {
        data: standing,
        competitionType,
        tournamentDetails: tournament,
      };
    },
    enabled:
      sportId !== null && data?.lastSeason?.id !== undefined && !isLoading,
    refetchOnWindowFocus: false,
  });

  const {
    data: matchesData = {},
    isLoading: isLoadingMatches,
    isError: isErrorMatches,
  } = useQuery({
    queryKey: ["get-Matches-afcon"],
    queryFn: () =>
      apiGetMatchesFn({
        month: date.getMonth() + 1,
        year: date.getFullYear(),
        service_id: serviceId,
        tournament_id: id,
      }),
    select: (data) => {
      const allMatches = data.data.data;
      const comingMatchesStatus = [1, 3, 4];
      const comingMatchesArr = allMatches?.filter((match) =>
        comingMatchesStatus.includes(match?.matchStatus),
      );
      const playedMatchesStatus = [5];
      const playedMatchesArr = allMatches?.filter((match) =>
        playedMatchesStatus.includes(match?.matchStatus),
      );

      return {
        comingMatchesArr,
        playedMatchesArr,
      };
    },
    enabled: serviceId !== null,
    refetchOnWindowFocus: false,
  });

  const handelTabClick = (selectedKey) => {
    history.push(`/africa/tournament/870/${selectedKey}`, {
      previousPathname: history.location.pathname,
    });
    setSelectedKey(selectedKey);
  };
  useEffect(() => {
    setSelectedKey(currentTab);
  }, [currentTab]);

  const [limitMatches, setlimitMatches] = useState({
    comingMatches: 6,
    playedMatches: 6,
  });

  const handlelimitMatches = (type) => {
    if (type === "coming") {
      if (matchesData?.comingMatchesArr?.length < limitMatches?.comingMatches)
        return;

      return setlimitMatches((prev) => ({
        ...prev,
        comingMatches: prev.comingMatches + 6,
      }));
    }

    if (type === "played") {
      if (matchesData?.playedMatchesArr?.length < limitMatches?.playedMatches)
        return;

      return setlimitMatches((prev) => ({
        ...prev,
        playedMatches: prev.playedMatches + 6,
      }));
    }
  };
  const phoneNum = getUserPhoneNumbers()[0];

  const {
    data: getAllpredictionData = [],
    isLoading: isLoadingPrediction,
    refetch,
  } = useQuery({
    queryKey: ["getAll-prediction"],
    queryFn: () =>
      getAllPredictionMatches({
        msisdn: phoneNum,
        tournament_id: 870,
      }),
    enabled: !!phoneNum,
    refetchOnWindowFocus: false,
  });

  const isIncludePrediction = (arr1 = [], arr2 = []) => {
    const arr1WithIncludesProperty = arr1?.map((obj1) =>
      arr2?.includes(obj1.id)
        ? { ...obj1, predictied: true }
        : { ...obj1, predictied: false },
    );

    return arr1WithIncludesProperty;
  };

  const handleClickPrediction = (teamsObj) => {
    setShowPredictAndWin(true);
    SetTeams(teamsObj);
  };

  useEffect(() => {
    setlimitMatches({ comingMatches: 6, playedMatches: 6 });
  }, [pathname]);

  return (
    <div className='african-nations-cup'>
      <div className='header'>
        <figure>
          <img src={cafLogo} alt='caf-logo' />
          <figcaption>كأس الأمم الأفريقية</figcaption>
        </figure>

        <Nav
          activeKey={selectedKey}
          onSelect={(selectedKey) => handelTabClick(selectedKey)}
          className='header__navs'>
          <Nav.Item>
            <Nav.Link eventKey='overview'>نظره عامة</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='matches'>المباريات</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='news'>الأخبار</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='videos'>الفيديوهات</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='team-fans'>مشجعي المنتخب</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='standing'>الترتيب</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className='body'>
        <Container>
          <Tabs activeKey={selectedKey}>
            <Tab eventKey='overview'>
              <div className='overview-tab'>
                <div className='calendar'>
                  <MatchesCalendar
                    season_id={data?.lastSeason?.id}
                    tournament_id={870}
                  />
                </div>
                <div className='news'>
                  <SportsSectionHeader
                    arrowTitle={"كل الأحداث"}
                    title='أهم الأحداث'
                    navigateTo='/africa/tournament/870/news'
                  />
                  <div>
                    <TopStories
                      sport_id={IDS.SPORTS.FOOTBALL}
                      season_id={data?.lastSeason?.id}
                      items_count={4}
                      media_type={1}
                      tournament_id={id}
                      top_stories={true}
                    />
                  </div>
                </div>
                <div className='videos'>
                  <SportsSectionHeader
                    arrowTitle={"كل الفيديوهات"}
                    title='أهم الفيديوهات'
                    navigateTo='/africa/tournament/870/videos'
                  />
                  <div>
                    <TopStories
                      sport_id={IDS.SPORTS.FOOTBALL}
                      season_id={data?.lastSeason?.id}
                      items_count={4}
                      media_type={2}
                      tournament_id={id}
                      top_stories={true}
                    />
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey='matches'>
              <section className='matches-tab'>
                <div className='guess-result'>
                  <h3> توقع النتيجة واكسب مع تويست سبورتس</h3>
                </div>
                <div className='matches-afcon'>
                  <h4>المباريات القادمة من كأس أمم أفريقيا 2024</h4>
                  {isLoadingMatches || (isLoadingPrediction && phoneNum) ? (
                    <MatchesCalendarLoader />
                  ) : isErrorMatches ||
                    !matchesData?.comingMatchesArr?.length ? (
                    <ErrorMsg p={5} fs={"lg"} msg=' لا يوجد مباريات قادمة' />
                  ) : (
                    ""
                  )}
                  {!isLoadingMatches && !!matchesData?.comingMatchesArr && (
                    <div className='all-matches-afcon'>
                      {isIncludePrediction(
                        matchesData.comingMatchesArr,
                        getAllpredictionData,
                      )
                        .reverse()
                        .slice(0, limitMatches.comingMatches)
                        .map((match) => (
                          <div
                            className='match-card-afcon d-flex flex-column align-content-center'
                            key={match?.id}>
                            <MatchCard
                              el={match}
                              handleClickPrediction={handleClickPrediction}
                            />
                          </div>
                        ))}
                    </div>
                  )}
                  {!isLoadingMatches &&
                     matchesData?.comingMatchesArr?.length >
                    limitMatches.comingMatches &&  (
                      <button
                        className='show-more-afcon'
                        onClick={() => handlelimitMatches("coming")}>
                        عرض المزيد
                      </button>
                    )}
                </div>
                <div className='matches-afcon'>
                  <h4 className='played-matches-title'>
                    المباريات السابقة من كأس أمم أفريقيا 2024
                  </h4>
                  {isLoadingMatches ? (
                    <MatchesCalendarLoader />
                  ) : isErrorMatches ||
                    !matchesData?.playedMatchesArr?.length ? (
                    <ErrorMsg p={5} fs={"lg"} msg=' لا يوجد مباريات سابقة' />
                  ) : (
                    ""
                  )}
                  {!isLoadingMatches && !!matchesData?.playedMatchesArr && (
                    <div className='all-matches-afcon'>
                      {matchesData?.playedMatchesArr
                        ?.slice(0, limitMatches.playedMatches)
                        .map((match) => (
                          <div
                            className='match-card-afcon d-flex flex-column align-content-center'
                            key={match?.id}>
                            <MatchCard el={match} />
                          </div>
                        ))}
                    </div>
                  )}
                  {!isLoadingMatches &&
                    matchesData?.playedMatchesArr?.length >
                      limitMatches.playedMatches && (
                      <button
                        className='show-more-afcon'
                        onClick={() => handlelimitMatches("played")}>
                        عرض المزيد
                      </button>
                    )}
                </div>
              </section>
            </Tab>
            <Tab eventKey='news'>
              <div className="news-tab">
              <SportsSectionHeader title='كل الأخبار' />
              <AllMedia
                sport_id={sportId}
                service_id={serviceId}
                items_count={8}
                type={1}
              />
              </div>
            </Tab>
            <Tab eventKey='videos'>
              <div className="videos-tab">
              <SportsSectionHeader title='كل الفيديوهات' />
              <AllMedia
                sport_id={sportId}
                service_id={serviceId}
                items_count={8}
                type={2}
              />
              </div>
            </Tab>
            <Tab eventKey='team-fans'>
              <section className='team-fans'>
                <FanClub
                  isLoading={isLoadingTournamentStanding}
                  isError={isErrorTournamentStanding}
                  data={tournamentStanding?.data}
                />
                <div className='matches-fans'>
                  <h4>المباريات القادمة من كأس أمم أفريقيا 2024</h4>
                  {isLoadingMatches ? (
                    <MatchesCalendarLoader />
                  ) : isErrorMatches ||
                    !matchesData?.comingMatchesArr?.length ? (
                    <ErrorMsg p={5} fs={"lg"} msg=' لا يوجد مباريات قادمة' />
                  ) : (
                    ""
                  )}
                  {!isLoadingMatches && !!matchesData?.comingMatchesArr && (
                    <div className='all-matches'>
                      {isIncludePrediction(
                        matchesData.comingMatchesArr,
                        getAllpredictionData,
                      )
                        .reverse()
                        .slice(0, limitMatches.comingMatches)
                        .map((match) => (
                          <div
                            className='match-card-afcon d-flex flex-column align-content-center'
                            key={match?.id}>
                            <MatchCard
                              el={match}
                              handleClickPrediction={handleClickPrediction}
                            />
                          </div>
                        ))}
                    </div>
                  )}
                  {!isLoadingMatches &&
                     matchesData?.comingMatchesArr?.length >
                    limitMatches.comingMatches &&  (
                      <button
                        className='show-more-afcon'
                        onClick={() => handlelimitMatches("coming")}>
                        عرض المزيد
                      </button>
                    )}
                </div>
              </section>
            </Tab>
            <Tab eventKey='standing'>
              <div className='standing-tab'>
                <CupTournamentGroupsStanding
                  sport_id={sportId}
                  season_id={data?.lastSeason?.id}
                  isLoading={isLoadingTournamentStanding}
                  isError={isErrorTournamentStanding}
                  data={tournamentStanding.data}
                  tournamentDetails={tournamentStanding.tournamentDetails}
                />
              </div>
            </Tab>
          </Tabs>
          {showPredictAndWin && (
            <PredictAfconTeams
              el={teams}
              show={showPredictAndWin}
              onHide={() => setShowPredictAndWin(false)}
              reftechpredictionfn={refetch}
            />
          )}
        </Container>
      </div>
    </div>
  );
}
